import r from "./ghl-ui.es403.js";
function o(t) {
  return t === t && !r(t);
}
export {
  o as default
};
